<template>
  <transition name="fade" :duration="1000">
    <div
      class="modal animation-mode-forwards animation-duration-1000"
      :class="[type]"
      v-show="active"
    >
      <div class="modal__dialog">
        <transition name="fade-up" :duration="300">
          <div
            class="modal__content animation-duration-300 animation-mode-forwards"
            :class="[`modal__content--${type}`]"
            v-show="active"
          >
            <div class="modal__header flex justify-end">
              <button class="modal-close-button" @click="close()">
                <IconClose />
              </button>
            </div>
            <div class="modal__body">
              <template v-if="showContent">
                <slot></slot>
              </template>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
/** Icons */
import IconClose from '@/assets/icons/icon-close.svg'

export default {
  components: {
    IconClose,
  },

  props: {
    type: {
      type: String,
      default: 'default',
    },
  },

  data() {
    return {
      active: false,
      showContent: true,
    }
  },
  mounted() {
    window.addEventListener('keyup', this.escCloseModal)
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.escCloseModal)
  },

  watch: {
    active() {
      if (this.active) {
        this.$emit('open')
        this.showContent = true
      } else {
        setTimeout(() => {
          this.showContent = false
        }, 1000)
        this.$emit('close')
      }
    },
  },

  methods: {
    escCloseModal(eventKey) {
      if (this.active && eventKey.key === 'Escape') {
        this.close()
      }
    },
    toggle() {
      this.active = !this.active
    },

    open() {
      this.active = true
    },

    close() {
      this.active = false
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  @apply fixed top-0 right-0 bottom-0 left-0 z-50;
}

.modal__dialog {
  @apply flex justify-center items-center w-full h-full bg-black bg-opacity-50;
}

.modal__content {
  @apply bg-white;
}

.modal__content--default {
  @apply w-2/5;
}

.modal__header {
  @apply p-4;
}
</style>
